// extracted by mini-css-extract-plugin
export default {"drawnUnderline":"---------packages-corgi-x-src-components-Underline-Underline-module__drawnUnderline"};